import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ResourceService} from '../../services/resource/resource.service';
import {NavigationItem} from '../../model/navigation-item';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../../shared/page-names.enum';
import {Router} from '@angular/router';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';
import {ImageUtils} from '../../shared/utils/image/image-utils';
import {CarouselService} from '../../services/carousel/carousel.service';
import {takeUntil} from 'rxjs/operators';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-navigable-banner',
  templateUrl: './navigable-banner.component.html',
  styleUrls: ['./navigable-banner.component.less'],
  providers: [ResourceService]
})
export class NavigableBannerComponent extends SelectableNavigationItem implements OnInit {
  @Input() pack: TvShopEntertainmentPack;

  @Output()
  selectedCarouselItem: EventEmitter<NavigationItem> = new EventEmitter<NavigationItem>();

  @ViewChild('bannerDiv') bannerDiv: ElementRef;
  @ViewChild('logoDiv') logoDiv: ElementRef;

  constructor(private navigationService: NavigationService,
              private router: Router,
              private carouselService: CarouselService,
              private changeDetector: ChangeDetectorRef,
              private stateService: TvShopStateService
  ) {
    super();
    this.y = 0;
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, PageNames.HOMEPAGE);

    this.carouselService.highlightedImages$.pipe(takeUntil(this.stopSubscription)).subscribe(imageArray => {
      if (imageArray && this.bannerDiv) {
        this.bannerDiv.nativeElement.appendChild(imageArray[this.carouselService.highlightedOmapiId + '-banner']);
        this.logoDiv.nativeElement.appendChild(imageArray[this.carouselService.highlightedOmapiId + '-logo']);
      }
    });
  }

  onEnter() {
    this.stateService.setSelectedTvShopEntertainmentPack(this.pack);
    this.router.navigate(['/product-details/' + this.pack.omapiId], {queryParamsHandling: 'merge'});
  }

  public get omapiId(): string {
    if (this.pack) {
      return this.pack.omapiId;
    }
    return undefined;
  }

  public get omapiIdForTitle(): string {
    if (this.pack) {
      return OmapiIdsUtils.getCorrectIdForResource(this.pack.omapiId);
    }
    return undefined;
  }

  activate(active: boolean): void {
    this.active = active;
    if (this.active) {
      this.selectedCarouselItem.emit(this);
    }
    this.changeDetector.detectChanges();
  }

  onBack(): void {
    window.close();
  }

  public get logoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
  }

  public isRedCarpetOrRedCarpetMore(): boolean {
    return (OmapiIdConstants.STREAMZ === this.carouselService.highlightedOmapiId || this.carouselService.highlightedOmapiId === OmapiIdConstants.RED_CARPET_MORE);
  }
}
